export default function calculateGrowthPercentage(start, end) {
  if (start === 0 || start === end) return 0;

  return ((end - start) / start) * 100;
}
